import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["Component", "pageProps"];
import React from "react";
import merge from "lodash-es/merge";
import { CART_APOLLO_CACHE_CONFIG } from "@catchoftheday/cart-components";
import { CMS_CONFIG_APOLLO_CACHE_CONFIG, nextAppHOC } from "@catchoftheday/common-vendors";
import { getEnvConfig, withEnvConfig } from "@catchoftheday/env-config";
import { ONEPASS_SHOP_APOLLO_CACHE_CONFIG } from "@catchoftheday/onepass";
import { PageLayout } from "../layouts/PageLayout";
import { jsx as ___EmotionJSX } from "@emotion/react";

function ShopfrontApp(_ref) {
  var Component = _ref.Component,
      pageProps = _ref.pageProps,
      rest = _objectWithoutProperties(_ref, _excluded);

  var host = rest.host,
      disablePageLayout = rest.disablePageLayout;

  if (disablePageLayout) {
    return ___EmotionJSX(Component, _extends({}, pageProps, rest));
  } // Only apply page layout if the request does not originate from a Kubernetes probe


  return ___EmotionJSX(PageLayout, {
    host: host
  }, ___EmotionJSX(Component, _extends({}, pageProps, rest, {
    host: host
  })));
}

export default withEnvConfig(nextAppHOC({
  graphqlEndpoint: function graphqlEndpoint() {
    return getEnvConfig().GRAPHQL_ENDPOINT;
  },
  apolloCacheConfig: merge(CMS_CONFIG_APOLLO_CACHE_CONFIG, CART_APOLLO_CACHE_CONFIG, ONEPASS_SHOP_APOLLO_CACHE_CONFIG),
  // eslint-disable-next-line n/no-process-env
  connectToDevTools: false,
  fonts: ["biennale", "montserrat"]
})(ShopfrontApp));